export enum PacketType
{
    UserConnect = 1,
    UserDisconnect = 2,
    LocalUserConnect = 3,
    TimelineSyncNodesRequest = 4, // unused
    TimelineSyncNodesInitResponse = 5,
    TimelineSyncNodesResponse = 6,
    TimelineSyncNodesDone = 7,
    TimelineSyncNodesFail = 8,
    NodeUpdateTitle = 9,
    NodeUpdateDescription = 10,
    NodeUpdateImage = 11,
    NodeUpdateStart = 12,
    NodeUpdateEnd = 13,
    NodeAddTag = 14,
    NodeRemoveTag = 15,
    NodeAddConnection = 16,
    NodeRemoveConnection = 17,
    NodeCreate = 18,
    NodeDestroy = 19,
    TagCreate = 20,

    // begin TODO later *************
    TagDestroy = 21, // server code is there for this though
    // end TODO later ***************

    TimelineCreate = 22,
    TimelineDestroy = 23, // TODO: implement soft delete, rename to TimelineSoftDelete
    TimelineAddNode = 24,
    TimelineRemoveNode = 25,
    // TimelineDelete is later
    TimelineSyncTagsRequest = 26, // unused
    TimelineSyncTagsInitResponse = 27,
    TimelineSyncTagsResponse = 28,
    TimelineSyncTagsDone = 29,
    TimelineSyncTagsFail = 30, // unused
    FullSyncRequest = 31,
    UpdateConnectionText = 32,
    FullSyncTimelinesRequest = 33, // unused
    FullSyncTimelinesInitResponse = 34,
    FullSyncTimelinesResponse = 35,
    FullSyncTimelinesDone = 36,
    FullSyncTimelinesFail = 37, // unused
    TimelineSyncTimelineNodesRequest = 38, // unused
    TimelineSyncTimelineNodesInitResponse = 39,
    TimelineSyncTimelineNodesResponse = 40,
    TimelineSyncTimelineNodesDone = 41,
    TimelineSyncTimelineNodesFail = 42, // unused

    MapNodeCreate = 43,
    MapNodeDestroy = 44,
    MapNodeAddNode = 45, // unused
    MapNodeRemoveNode = 46, // unused

    FullSyncMapNodesRequest = 47, // unused
    FullSyncMapNodesInitResponse = 48,
    FullSyncMapNodesResponse = 49,
    FullSyncMapNodesDone = 50,
    FullSyncMapNodesFail = 51,
    TimelineDelete = 52, // TODO: rename to TimelineDestroy
    TimelineUpdateTitle = 53,

    NodeSetImportant = 54,

    TimelineAddTag = 55,
    TimelineRemoveTag = 56,
    TimelineUpdateDescription = 57,
    Chat = 58,

    ForceCloseConnection = 59,

    Ping = 60,
    Pong = 61,

    SetLocalUserData = 62,
    TimelineChangeMapPin = 63,
    ProjectChangeName = 64, // unused
    ProjectChangeDescription = 65, // unused
    ProjectNotifyMetadataChanged = 66,

    TimelineUpdateComments = 67,

    DeleteChat = 68,

    GetTimelineAccessList = 69,
    TimelineUpdateAccess = 70,
    
    TimelineSyncTimelineEventOrderingRequest = 71, // unused
    TimelineSyncTimelineEventOrderingInitResponse = 72,
    TimelineSyncTimelineEventOrderingResponse = 73,
    TimelineSyncTimelineEventOrderingDone = 74,
    TimelineSyncTimelineEventOrderingFail = 75, // unused

    TimelineUpdateEventOrdering = 76,

    NodeUpdateAudio = 77,
    NodeUpdateDateOptions = 78,
    ChangeMapData = 79,
    MapNodeEdit = 80,
    Notification = 81,

    NodeUpdateImageCaption = 82,

    TagUpdateTitle = 83,
    TagUpdateColor = 84,

    NodeUpdateColor = 85,
    
    SetFolder = 86,
    DeleteFolder = 87,
    TimelineSetFolder = 88,
    
    NodeUpdateVideo = 89,

    UpdateRateLimitInterval = 90,

    TimelineSyncRequest = 91,

    TimelineSyncTimelineTags = 92,

    TimelineSyncedTimelines = 93,

    UpdateConnectionDirection = 94,
    FolderUpdateAccess = 95,

    AsyncRequest = 254,
    AsyncResponse = 255,
}

export default class Packet
{
    public type : PacketType = 0;
    public data : any = null;

    constructor(type : PacketType, data : any)
    {
        this.type = type;
        this.data = data;
    }
}